if (!customElements.get('zen-quantity-offer')) {
  customElements.define('zen-quantity-offer', class extends HTMLElement {
    connectedCallback() {
      this.quantity = this.closest('.product-form__quantity')?.querySelector('input[name="quantity"]');
      if (!this.quantity) { this.hidden = true; return; }
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        this.quantity.value = event.target.value;
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }, options);
      this.quantity.addEventListener('change', () => this.sync(), options);
      this.quantity.addEventListener('input', () => this.sync(), options);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.quantity, { attributes: true, attributeFilter: ['min', 'max', 'step', 'value', 'disabled'] });
      this.sync();
    }
    sync() {
      const quantity = Number(this.quantity.value);
      const min = Number(this.quantity.min || 1);
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      const step = Number(this.quantity.step || 1);
      this.querySelectorAll('input[type="radio"]').forEach(radio => {
        const count = Number(radio.value);
        radio.disabled = this.quantity.disabled || count < min || count > max || (count - min) % step !== 0;
        radio.checked = count === (quantity >= 3 ? 3 : quantity);
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
